import { Col, Row } from "antd";
import ParameterCardLayout from "./ParameterCardLayout";
import { UNITS } from "../../Common/Constants";

const ParameterCard = ({ stackData }) => {
  return (
    <Row gutter={[16, 16]} className="mt1">
      <Col xs={24} sm={24} md={24} lg={24} xl={12}>
        <ParameterCardLayout
          header="DC Current"
          unit={`(${UNITS.AMPERE})`}
          belowRange={stackData?.data?.dcCurrent?.belowRange}
          aboveRange={stackData?.data?.dcCurrent?.aboveRange}
          minValue={stackData?.maxMinData?.minDcCurrent}
          maxValue={stackData?.maxMinData?.maxDcCurrent}
        />
      </Col>
      <Col xs={24} sm={24} md={24} lg={24} xl={12}>
        <ParameterCardLayout
          header="DC Voltage"
          unit={`(${UNITS.VOLTS})`}
          belowRange={stackData?.data?.dcVoltage?.belowRange}
          aboveRange={stackData?.data?.dcVoltage?.aboveRange}
          minValue={stackData?.maxMinData?.minDcVoltage}
          maxValue={stackData?.maxMinData?.maxDcVoltage}
        />
      </Col>
      <Col xs={24} sm={24} md={24} lg={24} xl={12}>
        <ParameterCardLayout
          header="MCS Temperature"
          unit={`(${UNITS.CELSIUS})`}
          belowRange={stackData?.data?.mcsTemp?.belowRange}
          aboveRange={stackData?.data?.mcsTemp?.aboveRange}
          minValue={stackData?.maxMinData?.minMcsTemp}
          maxValue={stackData?.maxMinData?.maxMcsTemp}
        />
      </Col>
      <Col xs={24} sm={24} md={24} lg={24} xl={12}>
        <ParameterCardLayout
          header="Motor Temperature"
          unit={`(${UNITS.CELSIUS})`}
          belowRange={stackData?.data?.motorTemp?.belowRange}
          aboveRange={stackData?.data?.motorTemp?.aboveRange}
          minValue={stackData?.maxMinData?.minMotorTemp}
          maxValue={stackData?.maxMinData?.maxMotorTemp}
        />
      </Col>
    </Row>
  );
};

export default ParameterCard;
